<template>
  <div class="action-sheet">
    <action-sheet v-model="show" :close-on-click-overlay="false">
      <navigation :customClickEvent="true" :isPopUp="true">
        <div slot="left" class="left-nav-button" @click="$emit('on-apiSheetClose')">返回</div>
      </navigation>
      <div class="content">
        <api-page
          ref="apiPage"
          :isBottomSheet="true"
          @showListPop="receiveShowListPop"
          position="product_toast"
          :parentPageType="pageType"
        />
      </div>
    </action-sheet>
  </div>
</template>

<script>
import { ActionSheet } from 'vant'
import apiPage from './api-auth/api-page'
export default {
  components: {
    ActionSheet,
    apiPage
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  methods: {
    receiveShowListPop (items) {
      this.$emit('needsShowListPop', items)
    },
    confirmApply (items) {
      this.$refs.apiPage.receiveApplyAction(items)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.action-sheet {
  background: red;

  .left-nav-button {
    font-size: 28px;
    color: #666;
    margin-left: 31px;
  }

  .content {
    height: 1365px;
    padding: 10px 0px;
  }
}
</style>